import { render, staticRenderFns } from "./downloadButtons.vue?vue&type=template&id=16096252&scoped=true&"
import script from "./downloadButtons.vue?vue&type=script&lang=js&"
export * from "./downloadButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16096252",
  null
  
)

export default component.exports